import Hero from "./Section/Hero";
import AboutZeuss from "./Section/AboutZeuss";
import Ecosystem from "./Section/Ecosystem";
import Token from "./Section/Token";
import Tokenomics from "./Section/Tokenomics";
import Stories from "./Section/Stories";
import CompareTable from "./Section/CompareTable";
import Faq from "./Section/Faq";
import Launch from "./Section/Launch";
import StripeCheckout from "../Chckeout/Stripe";
import { Link } from "react-router-dom";
import ZeussToken from "../../../Contract/zeussToken.json";
const Home = () => {
  return (
    <>
      <div className="topbar">
        <h4>
          $ZEUSS Contract Address{" "}
          <Link
            target="_blank"
            to={`https://etherscan.io/token/${ZeussToken.address}`}
          >
            {ZeussToken.address}
          </Link>
        </h4>
      </div>
      {/* <StripeCheckout /> */}
      <div className="wrapper">
        <Hero />
        <AboutZeuss />
        <Ecosystem />
        <Token />
        <Tokenomics />
        <CompareTable />
        <Faq />
        <Stories />
        <Launch />
      </div>
    </>
  );
};
export default Home;
